import React, { FC, PropsWithChildren } from 'react';

import styles from './PagePanelHeader.module.scss';

const PagePanelHeader: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['root']}>{children}</div>
);

export { PagePanelHeader };
